import CsToolRecoveryAccountScreen from './recovery-account';

export default CsToolRecoveryAccountScreen;
